import { values } from './enums'

const _enum = {
  Unbegun: 0,
  Unfinished: 1,
  Finished: 2,
  Sent: 3,
  Rejected: 4,
  Accepted: 5,
  Error: 6
}

export const ReportSubmissionState = {
  enumName: 'ReportSubmissionState',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/ReportSubmissionState.js